export const ACTION = {
    GET_SIP_BANNER_CONTENT: 'GET_SIP_BANNER_CONTENT',
    GET_SIP_DISCLAIMER_CONTENT: 'GET_SIP_DISCLAIMER_CONTENT',
    POST_SIP_CALL_US: 'POST_SIP_CALL_US',
};